module.exports = __webpack_public_path__ + "img/grey_014.28091080.png";